const RANGE_CONFIG = {
  "1m": { windowMs: 60 * 1000, buckets: 12, label: "Last 1 min" },
  "5m": { windowMs: 5 * 60 * 1000, buckets: 12, label: "Last 5 min" },
  "1h": { windowMs: 60 * 60 * 1000, buckets: 12, label: "Last 1 hour" },
};

const SERIES_COLORS = {
  users: "#8bffb0",
  revenue: "#ffb86b",
  traffic: "#8ca7ff",
};

function getToken() {
  try {
    return localStorage.getItem("th_token") || localStorage.getItem("token") || "";
  } catch {
    return "";
  }
}

function clampRange(range) {
  return RANGE_CONFIG[range] ? range : "5m";
}

function createBuckets(range) {
  const key = clampRange(range);
  const cfg = RANGE_CONFIG[key];
  const now = Date.now();
  const start = now - cfg.windowMs;
  const bucketMs = Math.max(Math.floor(cfg.windowMs / cfg.buckets), 1000);
  const buckets = [];

  for (let i = 0; i < cfg.buckets; i += 1) {
    const at = start + (i * bucketMs);
    buckets.push({
      timestamp: at,
      label: new Date(at).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: key === "1m" ? "2-digit" : undefined,
      }),
      users: 0,
      revenue: 0,
      traffic: 0,
    });
  }

  return { buckets, start, end: now, bucketMs, range: key };
}

function buildMockDashboard(range = "5m") {
  const { buckets, range: safeRange } = createBuckets(range);
  const baseUsers = 18 + Math.floor(Math.random() * 12);
  const baseRevenue = 22000 + Math.floor(Math.random() * 15000);
  const baseTraffic = 120 + Math.floor(Math.random() * 80);
  const wave = Math.sin(Date.now() / 7000) * 4;

  buckets.forEach((bucket, index) => {
    const drift = index / 3;
    bucket.users = Math.max(1, Math.round(baseUsers + wave + drift + (Math.random() * 3)));
    bucket.revenue = Math.max(500, Math.round(baseRevenue + (drift * 1700) + (Math.random() * 2200)));
    bucket.traffic = Math.max(10, Math.round(baseTraffic + (index * 2) + (Math.random() * 18)));
  });

  const pie = [
    { label: "Calculators", value: 34, color: SERIES_COLORS.users },
    { label: "Jobs", value: 28, color: SERIES_COLORS.traffic },
    { label: "Profiles", value: 22, color: SERIES_COLORS.revenue },
    { label: "Other", value: 16, color: "#5b6156" },
  ];

  const bars = [
    { label: "Candidates", value: 18 + Math.round(Math.random() * 8), color: SERIES_COLORS.users },
    { label: "Recruiters", value: 6 + Math.round(Math.random() * 5), color: SERIES_COLORS.traffic },
    { label: "Jobs", value: 12 + Math.round(Math.random() * 7), color: SERIES_COLORS.revenue },
    { label: "Complaints", value: 2 + Math.round(Math.random() * 4), color: "#ff7a7a" },
    { label: "Reviews", value: 4 + Math.round(Math.random() * 6), color: "#b08cff" },
  ];

  return {
    source: "mock",
    range: safeRange,
    generated_at: new Date().toISOString(),
    users: buckets[buckets.length - 1]?.users || 0,
    revenue: buckets[buckets.length - 1]?.revenue || 0,
    traffic: buckets[buckets.length - 1]?.traffic || 0,
    timestamps: buckets.map((item) => item.timestamp),
    series: {
      users: buckets.map((item) => item.users),
      revenue: buckets.map((item) => item.revenue),
      traffic: buckets.map((item) => item.traffic),
    },
    bars,
    pie,
    top_pages: [
      { page_label: "Salary Calculator", page_path: "/calculator/salary", views: 36, unique_visitors: 18, avg_duration: 42000 },
      { page_label: "Jobs", page_path: "/employee/jobs", views: 28, unique_visitors: 16, avg_duration: 25000 },
      { page_label: "Recruiter Dashboard", page_path: "/recruiter/dashboard", views: 22, unique_visitors: 9, avg_duration: 31000 },
    ],
    calculators: [
      { page_label: "Salary Calculator", page_path: "/calculator/salary", views: 22, unique_visitors: 14, avg_duration: 36000 },
      { page_label: "HRA Calculator", page_path: "/calculator/hra", views: 18, unique_visitors: 12, avg_duration: 29000 },
      { page_label: "PF Calculator", page_path: "/calculator/pf", views: 16, unique_visitors: 11, avg_duration: 24000 },
    ],
    notifications: [
      { id: "mock-1", message: "Mock analytics stream is active.", at: new Date().toISOString() },
    ],
  };
}

function normalizeResponse(data, range) {
  const safe = createBuckets(range);
  const series = data?.series || {};
  const timestamps = Array.isArray(data?.timestamps) && data.timestamps.length
    ? data.timestamps
    : safe.buckets.map((item) => item.timestamp);
  const fallback = buildMockDashboard(range);

  const users = Array.isArray(series.users) && series.users.length ? series.users : (Array.isArray(data?.users) ? data.users : safe.buckets.map((item) => item.users));
  const revenue = Array.isArray(series.revenue) && series.revenue.length ? series.revenue : (Array.isArray(data?.revenue) ? data.revenue : safe.buckets.map((item) => item.revenue));
  const traffic = Array.isArray(series.traffic) && series.traffic.length ? series.traffic : (Array.isArray(data?.traffic) ? data.traffic : safe.buckets.map((item) => item.traffic));

  const bars = Array.isArray(data?.bars) && data.bars.length ? data.bars : fallback.bars;
  const pie = Array.isArray(data?.pie) && data.pie.length ? data.pie : fallback.pie;

  return {
    source: data?.source || "api",
    range: createBuckets(range).range,
    generated_at: data?.generated_at || data?.generatedAt || new Date().toISOString(),
    users: Number(data?.users || users[users.length - 1] || 0),
    revenue: Number(data?.revenue || revenue[revenue.length - 1] || 0),
    traffic: Number(data?.traffic || traffic[traffic.length - 1] || 0),
    timestamps,
    series: { users, revenue, traffic },
    bars,
    pie,
    top_pages: Array.isArray(data?.top_pages) ? data.top_pages : [],
    calculators: Array.isArray(data?.calculators) ? data.calculators : [],
    notifications: Array.isArray(data?.notifications) ? data.notifications : [],
  };
}

export async function fetchDashboardData(range = "5m") {
  const safeRange = clampRange(range);
  try {
    const headers = { "Content-Type": "application/json" };
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(`/api/dashboard?range=${encodeURIComponent(safeRange)}`, {
      method: "GET",
      headers,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Dashboard API returned ${response.status}`);
    }

    const payload = await response.json();
    return normalizeResponse(payload, safeRange);
  } catch (_error) {
    return buildMockDashboard(safeRange);
  }
}

export function getRangeLabel(range) {
  const safeRange = clampRange(range);
  return RANGE_CONFIG[safeRange].label;
}
